import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/bundle";
import "react-loading-skeleton/dist/skeleton.css";

import ProductCard from "../ProductCard";
import Skeleton from "react-loading-skeleton";

const SwiperCarousel = ({
  productList,
  setShow,
  newArrivalsLoading,
  newArrivalsError,
  regularProductsLoading,
  regularProductError,
}) => {
  let descendingProductList;
  if (productList) {
    descendingProductList = [...productList]?.reverse();
  }

  return (
    <Swiper
      slidesPerGroup={1}
      spaceBetween={10}
      loopFillGroupWithBlank={true}
      navigation={true}
      breakpoints={{
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        // when window width is >= 640px
        700: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        1300: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        1501: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
      }}
      modules={[Pagination, Navigation]}
      className="mySwiper"
    >
      {(newArrivalsLoading || regularProductsLoading) && <Skeleton count={5} />}
      {(newArrivalsError || regularProductError) && (
        <p className="text-center text-danger fs-3">
          There are something wrong!..
        </p>
      )}
      {productList &&
        descendingProductList?.map((product) => (
          <SwiperSlide
            key={product?._id}
            className="h-auto d-flex justify-content-center"
          >
            <ProductCard setShow={setShow} cart={product} />
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

export default SwiperCarousel;
